export const FILTERS = 'filters';

export const FILTER_PERIOD = 'relativePeriod';
export const FILTER_APPLICATIONS = 'applications';
export const FILTER_AFFILIATES = 'affiliates';
export const FILTER_CAMPAIGNS = 'campaigns';
export const FILTER_TRAFFIC_TYPE = 'trafficType';
export const FILTER_NETWORKS = 'networks';
export const FILTER_CHANNELS = 'channels';
export const FILTER_OWNERS = 'owners';
export const FILTER_MANAGERS = 'managers';
export const FILTER_PLATFORMS = 'platforms';
export const DIMENSION = 'dimension';

export const METRICS = 'metrics';
export const COLUMNS = 'columns';
export const PRESET_ID = 'presetID';
export const TABLE_SETTINGS = 'tableSettings';
export const LIMIT = 'limit';
export const OFFSET = 'offset';
export const ORDER_BY = 'orderBy';
export const ORDER_DIR = 'orderDir';

const LAST_7_DAYS = 0;
const TRAFFIC_TYPE_ADVERTISING = 1;
const METRICS_TOTAL_REGS = 'OverallTotalRegs';
const METRICS_TOTAL_SPEND = 'SpentUsd';
const METRICS_TOTAL_CPI = 'OverallTotalCpi';
const METRICS_TOTAL_ROAS = 'OverallTotalRoasD7';
const DIMENSION_AFFILIATE = 'Affiliate';

export const initialState = {
  [PRESET_ID]: undefined,
  [DIMENSION]: DIMENSION_AFFILIATE,
  [FILTERS]: {
    [FILTER_PERIOD]: LAST_7_DAYS,
    [FILTER_TRAFFIC_TYPE]: TRAFFIC_TYPE_ADVERTISING,
  },
  [COLUMNS]: [
    METRICS_TOTAL_REGS,
    METRICS_TOTAL_SPEND,
    METRICS_TOTAL_CPI,
    METRICS_TOTAL_ROAS,
  ],
  [METRICS]: [METRICS_TOTAL_REGS, METRICS_TOTAL_SPEND],
  [TABLE_SETTINGS]: {
    [LIMIT]: 25,
    [OFFSET]: 0,
    [ORDER_BY]: METRICS_TOTAL_REGS,
    [ORDER_DIR]: 'desc',
  },
};
